import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '#components/atoms/skeleton';
import { ChartContext, ChartContextOptions } from '#components/chart/context/chartContext';
import { useChartObserver } from '#components/chart/hooks/useChartObserver';
import { ParseChartData } from '#components/chart/types';
import { cn } from '#lib/utils';
import { ReactNode } from 'react';
export type ChartConfigProps<T extends ParseChartData> = {
  className?: string;
  options?: Partial<ChartContextOptions>;
} & {
  data: T;
};
const colors = {
  HIGHLIGHT_POSITIVE: '#D6EEE0',
  HIGHLIGHT_NEGATIVE: '#FEDEE1',
  TOOLTIP_CURRENT: '#0072CE',
  TOOLTIP_TARGET: '#009639',
  TOOLTIP_TARGET_BOTH: '#33AB61',
  CURRENT_LINE: '#0072CE',
  CURRENT_DOTS: '#0072CE',
  CURRENT_DOT_FILL: '#D6E9F8',
  CURRENT_ACTIVE_DOT: '#0072CE',
  XAXIS_LINE: '#ADADAD',
  XAXIS_TEXT: '#0072CE',
  YAXIS_TEXT: '#ADADAD',
  UNIT_TEXT: '#585C5F',
  REFERENCE_LINE: '#009639',
  CURSOR_LINE: '#D6D6D6',
  TARGET_AXIS_TEXT: '#ADADAD',
  TARGET_AXIS_ACTIVE_TEXT: '#000000',
  TARGET_LINE: '#ADDEC0',
  TARGET_DOTS: '#ADDEC0',
  TARGET_ACTIVE_DOT: '#009639',
  GRID_LINE: '#F2F2F2',
  DOT_FILL: '#F2F2F2'
};
const CHART_DEFAULT_OPTIONS: ChartContextOptions = {
  reversed: false,
  highLightedZone: undefined,
  colors,
  size: 'sm'
};
export const ChartConfig = t0 => {
  const $ = _c(26);
  const {
    children,
    className,
    data,
    options
  } = t0;
  const t1 = options?.colors;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      ...CHART_DEFAULT_OPTIONS.colors,
      ...t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== options || $[3] !== t2) {
    t3 = {
      ...CHART_DEFAULT_OPTIONS,
      ...options,
      colors: t2
    };
    $[2] = options;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const mergedOptions = t3;
  const {
    containerRef,
    isRendered,
    isVisible,
    isCalculated
  } = useChartObserver();
  let t4;
  if ($[5] !== data || $[6] !== isCalculated || $[7] !== mergedOptions) {
    t4 = {
      data,
      options: mergedOptions,
      isCalculated
    };
    $[5] = data;
    $[6] = isCalculated;
    $[7] = mergedOptions;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== className) {
    t5 = cn("relative h-full w-full", className);
    $[9] = className;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== children || $[12] !== data || $[13] !== isVisible) {
    t6 = !isVisible ? null : data.isInvalid ? <div className="w-full absolute top-4 left-3 right-4 bottom-2 bg-semantic-surface-faint flex items-center justify-center"><p>Graafikut ei ole võimalik kuvada, sest andmed puuduvad</p></div> : children;
    $[11] = children;
    $[12] = data;
    $[13] = isVisible;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== isRendered || $[16] !== isVisible) {
    t7 = !isRendered || !isVisible ? <Skeleton className="w-full absolute top-4 left-3 right-4 bottom-2 bg-semantic-surface-faint animate-pulse" /> : null;
    $[15] = isRendered;
    $[16] = isVisible;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== containerRef || $[19] !== t5 || $[20] !== t6 || $[21] !== t7) {
    t8 = <div className={t5} ref={containerRef}>{t6}{t7}</div>;
    $[18] = containerRef;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t4 || $[24] !== t8) {
    t9 = <ChartContext.Provider value={t4}>{t8}</ChartContext.Provider>;
    $[23] = t4;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
};